export default "__VITE_ASSET__Sf5EsgJV__"